import React, { Fragment, useState } from "react";
import { ExamType, UserTypeId } from "../../common/const";
import CommonCard from "../../common/components/CommonCard";
import { Box, LinearProgress, linearProgressClasses, styled, Typography } from "@mui/material";
import theme from "../../theme";
import CommonButton from "../../common/components/CommonButton";
import ScoreDialog from "./ScoreDialog";
import { useSelector } from "react-redux";

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 6,
    borderRadius: 5,
    marginTop: 8,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[200],
        ...theme.applyStyles('dark', {
            backgroundColor: theme.palette.grey[800],
        }),
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: theme.palette.secondary.main,
        ...theme.applyStyles('dark', {
            backgroundColor: theme.palette.secondary.main,
        }),
    },
}));

const Exam = ({
    Score,
    type,
    getScoreData,
    coachData
}) => {
    const { user } = useSelector((state) => state.auth);
    const [dialogOpen, setDialogOpen] = useState(false);

    return (
        <Fragment>
            <ScoreDialog
                addOpen={dialogOpen}
                setAddOpen={setDialogOpen}
                isDreamScore
                getScoreData={getScoreData}
            />
            <CommonCard
                borderRadius={2}
                border={`1px solid #0000001A`}
                content={
                    <Fragment>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Box>
                                <Typography fontWeight={600}>Dream Score</Typography>
                            </Box>
                            <Box sx={{
                                background: theme.palette.background.main,
                                height: '40px',
                                padding: '9px 20px',
                                borderRadius: '20px'
                            }}>
                                <Typography fontSize={13} color={theme.palette.background.dark}>Standard Uni</Typography>
                            </Box>
                        </Box>
                        <Box display="flex" justifyContent="space-between" alignItems="end" mb={2}>
                            <Box sx={{
                                background: theme.palette.cardbackground.secondary,
                                height: '40px',
                                padding: '9px 20px',
                                borderRadius: '20px'
                            }}>
                                <Typography fontSize={15} color={theme.palette.background.dark} fontWeight={600}><span style={{ color: theme.palette.secondary.main }}>{Score?.goalData?.target_composite}</span> Target</Typography>
                            </Box>
                            <Box>
                                <Typography fontWeight={600} color={theme.palette.secondary.main}>{(Score?.goalData?.target_composite && Score?.composite_score) ? (Score?.goalData?.target_composite - Score?.composite_score) : 0} points to your dream score</Typography>
                            </Box>
                        </Box>
                        <BorderLinearProgress variant="determinate" value={((Score.score / Score.dreamScore) * 100)} />
                        <Typography fontSize={14} fontWeight={600} color={theme.palette.background.dark}>Your most recent {type} score will be used to compare against your target score.</Typography>
                        <CommonCard
                            borderRadius={2}
                            background="#FFFCCF"
                            content={
                                <Fragment>
                                    <Typography fontWeight={600} color={theme.palette.primary.main}>Coach Insight</Typography>
                                    <Typography fontSize={14} color={theme.palette.background.dark}>
                                        {type === ExamType.SAT ? coachData?.sat_student_suggestion : coachData?.act_student_suggestion }
                                    </Typography>
                                </Fragment>
                            }
                        />
                        {user?.user_type_id === UserTypeId.Student &&
                        (<CommonButton
                            marginTop={3}
                            label="Adjust Dream Score"
                            fontWeight={600}
                            handleClick={() => setDialogOpen(true)}
                            marginBottom="0px"
                        />)}
                    </Fragment>
                }
            />
        </Fragment>
    )
}
const Score = ({
    testType,
    getScoreData,
    latestScore,
    coachData
}) => {
    return (
        testType === ExamType.SAT ? (
            <Exam Score={latestScore} type={testType} getScoreData={getScoreData} coachData={coachData}/>
        ) : (
            <Exam Score={latestScore} type={testType} getScoreData={getScoreData} coachData={coachData} />
        )
    )
}

export default Score;